import { List, Datagrid, TextField, NumberField, TextInput } from "react-admin";
import { CopyableField } from "../../../../shared/fields";

const filters = [
  <TextInput key="roundId" source="roundId" label="Round ID" alwaysOn />,
  <TextInput key="userId" source="userId" label="User ID" alwaysOn />,
];

export const WalletRequestList = () => (
  <List filters={filters} perPage={25}>
    <Datagrid bulkActionButtons={false}>
      <CopyableField source="id" label="ID" />
      <TextField source="action" label="Action" />
      <TextField source="actionType" label="Type" />
      <NumberField
        source="amount"
        label="Amount"
        options={{ minimumFractionDigits: 2 }}
      />
      <TextField source="currency" label="Cur" />
      <CopyableField source="transactionId" label="Tx ID" sortable={false} />
      <CopyableField source="roundId" label="Round ID" sortable={false} />
      <CopyableField source="userId" label="User ID" sortable={false} />
      <TextField source="status" label="Status" />
      <NumberField source="resultCode" label="Code" />
    </Datagrid>
  </List>
);
